// src/services/apiClient.ts
// Cloud Functions API への認証付きリクエストヘルパー。
// 決済系エンドポイントは Firebase ID トークン (Bearer) を必須とするため、
// 現在のユーザーのトークンを付与して POST する。
import { auth } from '@/firebase';

export const FN_BASE = 'https://us-central1-chusho-app.cloudfunctions.net/api';

/**
 * 認証付き POST。ログイン中ユーザーの ID トークンを Authorization ヘッダに付与する。
 * 未ログイン時はエラーを投げる。
 */
export async function authedPost(path: string, body: unknown): Promise<Response> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('ログインが必要です。');
  }
  const token = await user.getIdToken();
  const url = path.startsWith('http') ? path : `${FN_BASE}${path}`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
}

/**
 * 認証付き GET。ログイン中ユーザーの ID トークンを Authorization ヘッダに付与する。
 * 管理者専用エンドポイント(SNS設定など)で使用。
 */
export async function authedGet(path: string): Promise<Response> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('ログインが必要です。');
  }
  const token = await user.getIdToken();
  const url = path.startsWith('http') ? path : `${FN_BASE}${path}`;
  return fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
}
